import React, { ComponentType } from 'react';
import { getLanguageDirection } from '../i18n';

function withDirection<P>(Component: ComponentType<P>) {
  const ComponentWithDirection = (props: Omit<P, 'data-rtl'>) => {
    const direction = getLanguageDirection();

    return <Component {...(props as P)} data-rtl={direction} />;
  };

  return ComponentWithDirection as any;
}

export default withDirection;
